import { createTheme } from '@mui/material/styles';
import { palette } from '@awarego-ui/components';

export const AwareGOTheme = createTheme({
    palette: {
        primary: { main: '#20A26B' },
        secondary: { main: '#ffffff' },
    },
    typography: {
        fontFamily: ['Nunito Sans', 'sans-serif'].join(','),
    },
    components: {
        MuiSlider: {
            styleOverrides: {
                thumb: ({ theme }) => ({
                    color: theme.palette.primary.main,
                    width: 22,
                    height: 22,
                    boxShadow: '0 0 0 3px white',
                    borderColor: '#ffffff',
                    borderWidth: 4,
                }),
                track: ({ theme }) => ({
                    height: 8,
                    color: theme.palette.primary.main,
                }),
                rail: {
                    color: '#afafaf',
                    height: 8,
                    opacity: 0.4,
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: '13px',
                    fontWeight: 700,
                    lineHeight: '18px',
                    padding: '6px 24px',
                    '&:first-child': {
                        marginTop: '4px',
                    },
                    '&:last-child': {
                        marginBottom: '4px',
                    },
                },
            },
        },
        MuiMenu: {
            styleOverrides: {
                list: {
                    minWidth: '100px',
                },
            },
        },
        MuiFormControlLabel: {
            styleOverrides: {
                label: {
                    fontWeight: '600',
                    letterSpacing: '0.04em',
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    marginTop: '4px',
                    '&&& input': {
                        margin: 0,
                        paddingLeft: '10px',
                        fontWeight: 'bold',
                        fontSize: '13px',
                        lineHeight: '18px',
                        paddingTop: '10px',
                        paddingBottom: '8px',
                        color: palette.graphite.ash,
                    },
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    color: '#c4c4c4',
                    '&.Mui-error': {
                        color: '#BE2024',
                    },
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                indicator: {
                    backgroundColor: '#c4c4c4',
                },
            },
        },
        MuiTooltip: {
            defaultProps: {
                enterTouchDelay: 100,
                leaveTouchDelay: 800,
            },
        },
    },
    breakpoints: {
        values: {
            md: 992,
        },
    },
});
